module.exports = __webpack_public_path__ + "img/signup_carousel_0.237b0d93.svg";